<template>
  <main>
    <div class="tab-header">
      <div class="container-fluid">
        <div class="mb-4 font-20">
          <strong>戶長</strong>
          <avatar
            class="mr-1 ml-1"
            :gender="Number(familyData.sex)"
            :size="20"
          />
          <strong
            class="link text-underline mr-1"
            @click="routeToCustDetail(familyData.csidno, familyData.name)"
            >{{ truncate(familyData.name, 12) }}</strong
          >
          <strong class="text-black font-16">
            <!-- {{`(${moment().diff(moment(familyData.birthday).format('YYYY-MM-DD'),'years',false)}歲)`}} -->
            ({{
              (parseInt(familyData.age) >= 0 ? familyData.age : "--") + "歲"
            }})
          </strong>
          <strong>的家戶</strong>
          <a
            @click="routeToHolder"
            to="/allHolder"
            class="btn btn-default float-right fw-600"
            >返回戶長列表</a
          >
          <!-- <a class="btn btn-default btn-sm m-0 ml-3" @click="createGroup()">新增群組</a> -->
        </div>

        <!-- <div class="d-flex justify-content-end"></div> -->

        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" @click="$router.push({ name: 'relation' })">
            <a
              class="nav-link show"
              role="tab"
              data-toggle="tab"
              id="familyRelationNavLink"
              :class="{ active: $route.name === 'relation' }"
              >家戶關係</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'policyInfo' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="policyInfoNavLink"
              :class="{
                active: $route.matched
                  .map((x) => x.name)
                  .includes('policyInfoContainer'),
              }"
              >保單資訊</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </div>
  </main>
</template>

<script>
import Avatar from "@/desktop/components/Avatar";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { dotNetJavaConcat } from "@/service";
import { log } from "util";
import RouteToCustDetailMixins from "@/mixins/RouteToCustDetail";

export default {
  name: "FamilyRelation",
  mixins: [commonMixin, RouteToCustDetailMixins],
  components: { Avatar },
  computed: {
    ...mapGetters(["UserItems"]),
    familyData() {
      if (!this.UserItems || this.UserItems.length < 1) {
        if (!localStorage.userItems) {
          return {
            sex: "1",
            name: "--",
            csidno: "--",
            age: "0",
          };
        } else {
          return JSON.parse(localStorage.userItems);
        }
      } else {
        if (typeof this.UserItems === 'string' || this.UserItems instanceof String){
          return JSON.parse(this.UserItems);
        }else{
          return this.UserItems;
        }
      }
    },
  },
  data() {
    return {};
  },
  methods: {
    moment,
    ...mapActions([
      "updateCustID",
      "updateSerNo",
      "updateAllHolderSearchData",
      "updateUserItems",
    ]),
    len(str) {
      return str.replace(/[^\x00-\xff]/g, "xx").length;
    },
    async callDotNet() {
      //20211124 從BOX回來CALL API 取得戶長資料(UserItems) 進家戶但不執行保健
      if (
        this.$route.query.concatCode &&
        this.$store.state.userInfo.userType === "box"
      ) {
        await dotNetJavaConcat(
          this.$store.state.userInfo.id,
          this.$route.query.concatCode
        ).then((result) => {
          if (result.header) {
            if (result.data) {
              let familyData = result.data.familydata;
              if (familyData) {
                this.updateUserItems(familyData);
                localStorage.userItems = JSON.stringify(familyData);
                this.setCustData(this.familyData.csidno);
              }
            } else {
              this.$toast.info({
                title: `新保健無此家戶(${this.$route.query.switch})`,
              });
              this.updateUserItems({});
              localStorage.userItems = "";
            }
          }
        });
      } else {
        this.setCustData(this.familyData.csidno);
      }
    },
    sub(str, n) {
      let l = 0;
      for (let i = 0; i < str.length; i++) {
        if (str[i].match(/[^\x00-\xff]/g)) {
          l += 2;
        } else {
          l++;
        }
        if (l >= n) {
          return str.substr(0, i + 1);
        }
      }
    },
    truncate(str, n) {
      if (str) {
        return this.len(str) > n ? this.sub(str, n) + "..." : str;
      } else {
        return "";
      }
    },
    routeToHolder() {
      this.updateAllHolderSearchData([]);
      this.$router.push({ name: `allHolder` });
      localStorage.checkMvBack = false;
    },
    setCustData(csid){
      if (!csid.includes("~")) {
        this.updateCustID(csid);
        this.updateSerNo("");
        localStorage.CustID = csid;
        localStorage.SerNo = "";
      } else {
        this.updateCustID("");
        this.updateSerNo(csid);
        localStorage.CustID = "";
        localStorage.SerNo = csid;
      }
    }
  },
  mounted() {
    this.callDotNet();
  },
};
</script>
<style>
.font-20 {
  font-size: 20px;
}
.font-16 {
  font-size: 16px;
}
.w-120 {
  width: 120px;
}
</style>

<style scoped>
.container-fluid {
  padding-left: 40px;
  padding-right: 40px;
}
</style>